module.exports = __webpack_public_path__ + "static/sport/title.8d7d4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/title.png
// module id = sfFk
// module chunks = 0